import React from "react";
import styled from "styled-components";
import Collapsible from "../reuse/Collapsible";
import DisplayField from "../reuse/DisplayField";
import { FieldGroup, DisplaySection, Section } from "../Styles";
import formatDate from "../../utils/formatDate";

const MainWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* gap: 20px; */
  padding-bottom: 20px;
  margin-top: -18px;
`;

export default function Information({ requestRecord }) {
  return (
    <MainWrapper>
      <Collapsible title="Requestor Information | Información del Solicitante">
        <DisplaySection>
          <Section style={{ flex: 2 }}>
            <FieldGroup>
              <DisplayField
                label="Your First Name"
                helpText="Su primer nombre"
                text={requestRecord?.firstName_F}
              />
              <DisplayField
                label="Your Last Name"
                helpText="Su apellido"
                text={requestRecord?.lastName_F}
              />
            </FieldGroup>
            <FieldGroup>
              <DisplayField
                label="Your Email"
                helpText="Su correo electrónico"
                text={requestRecord?.requestorEmail_F}
              />
              <DisplayField
                label="Your Phone Number"
                helpText="Su número de teléfono"
                text={requestRecord?.phoneNo_F}
              />
            </FieldGroup>
          </Section>

          <Section>
            <DisplayField
              label="Request Submitted"
              text={
                requestRecord?.requestSubmitted_F
                  ? formatDate(requestRecord?.requestSubmitted_F)
                  : ""
              }
            />
            <DisplayField
              label="Your Relationship to Client"
              text={requestRecord?.relationshipToClientEn_F}
            />
            <DisplayField
              label="Su Relacion al Cliente"
              text={requestRecord?.relationshipToClientEs_F}
            />
          </Section>
        </DisplaySection>
      </Collapsible>

      <Collapsible title="Client Information | Información del Cliente">
        <DisplaySection>
          <Section>
            <FieldGroup>
              <DisplayField
                label="Preferred Language"
                helpText="Idioma preferido"
                text={requestRecord?.preferredLanguage_F}
              />
              <DisplayField
                label="Client Name"
                helpText=""
                text={requestRecord?.clientName_F}
              />
            </FieldGroup>
            <FieldGroup>
              <DisplayField
                label="Phone Number"
                helpText="Número de teléfono"
                text={requestRecord?.clientPhoneNo_F}
              />
            </FieldGroup>
            <FieldGroup>
              <DisplayField
                label="Gender as it appears on your Government ID"
                helpText="Género tal como aparece en su identificación gubernamental"
                text={requestRecord?.gender_F}
              />
              <DisplayField
                label="Date of Birth"
                helpText="Fecha de nacimiento (MM-DD-AAAA)"
                text={
                  requestRecord?.dob_F ? formatDate(requestRecord?.dob_F) : ""
                }
              />
              <DisplayField
                label="Age"
                helpText="Edad"
                text={requestRecord?.age_F}
              />
            </FieldGroup>
            <FieldGroup>
              <DisplayField
                label="Address"
                helpText="Dirección física, ciudad, código postal, estado"
                text={requestRecord?.address_F}
              />
            </FieldGroup>
          </Section>
        </DisplaySection>
      </Collapsible>
    </MainWrapper>
  );
}
